<template>
<!--投料tab-->
    <div>
        <!--头部-->
        <div class="flex0">
            <el-select style="width: 145px"  class="marr4" v-model="isAccountTime" size="mini" filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in timeType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="begin_time"
                    formt="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_startDate')"　>
            </el-date-picker>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="end_time"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_endDate')"　>
            </el-date-picker>
            <el-input class="marr4" style="width: 15%" v-model="vcName" :placeholder="$t('promanagement_search_for_product_name_or_batch_number')"　 clearable size="mini"></el-input>
            <el-button  icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
            <el-button  type="primary"  :class="baseerp+'btn'" @click="feedDialog" :disabled="disabled" size="mini">{{$t('promanagement_feeding')}}</el-button>
            <!--<el-button  type="primary"  :class="baseerp+'btn'" @click="produceDialog">产出</el-button>-->
            <el-button  type="primary"  :class="baseerp+'btn'" @click="returnDialog" :disabled="disabled" size="mini">{{$t('promanagement_online_return')}}</el-button>
            <el-button  type="primary"  :class="baseerp+'btn'" @click.stop="lookreport"  size="mini">{{$t('promanagement_statistics')}}</el-button>
        </div>
        <!--列表-->
        <div>
            <el-table
                    border
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="highlightCurrentRow"
                    >
                <el-table-column
                        prop="i_id"
                        label="ID"
                        width="90"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('promanagement_raw_materials/finished_products')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_no"
                        :label="$t('promanagement_serial_number/production_batch_number')"
                        min-width="110"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_unit"
                        :label="$t('form_metering')"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="f_innum"
                        :label="$t('promanagement_quantity_of_feeding_materials')"
                        show-overflow-tooltip
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_innum_zb"
                        :label="$t('promanagement_100%_discount_for_feeding_quantity')"
                        show-overflow-tooltip
                        width="85"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_outnum"
                        :label="$t('promanagement_output_quantity')"
                        show-overflow-tooltip
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_outnum_zb"
                        :label="$t('promanagement_output_converted_to_100%_quantity')"
                        show-overflow-tooltip
                        width="85"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="dt_tltime"
                        :label="$t('promanagement_input_output_time')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_bc"
                        :label="$t('promanagement_classes')"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="vc_scxname"
                        :label="$t('promanagement_production_pine')"
                        width="70"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_note"
                        :label="$t('form_notes')"
                        width="50"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        :label="$t('form_enter_time')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="dt_accounttime"
                        :label="$t('promanagement_accountingTime')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_lruname"
                        :label="$t('form_input_person')"
                        width="80"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        :label="$t('form_operate')"
                        width="50">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text" size="small">{{scope.row.f_innum<0?$t('button_view'):$t('button_edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--投料dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="feedDialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="feedDialogVisible">
                <feeding-form :feeding="feeding" @close="cancelDialog" @getConsumeList="getConsumeList" ></feeding-form>
            </el-dialog>
        </div>
        <!--产出dialog-->
<!--        <div :class="baseerp+'div'">-->
<!--            <el-dialog-->
<!--                     width="1000px"-->
<!--                    :title="title"-->
<!--                    :visible.sync="produceDialogVisible"-->
<!--                    :close-on-click-modal="false"-->
<!--                    @close="cancelDialog"-->
<!--                    v-if="produceDialogVisible">-->
<!--                <produce-form :produce="produce" @close="cancelDialog" @getConsumeList="getConsumeList" @addLine="addLine"></produce-form>-->
<!--            </el-dialog>-->
<!--        </div>-->
        <!--在线退回dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="returnDialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="returnDialogVisible">
                <return-list :returnlist="returnlist" @close="cancelDialog" @getConsumeList="getConsumeList" ></return-list>
            </el-dialog>
        </div>
        <!--统计dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="1000px"
                    :title="title"
                    :visible.sync="StatisticsDialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="StatisticsDialogVisible">
                <statistics-sheet :sheet="sheet" @close="cancelDialog" @getConsumeList="getConsumeList" ></statistics-sheet>
            </el-dialog>
        </div>
        <!--表报 -->
        <div class="">
        <reportdialog  ref="mydialog"   ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>
        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import FeedingForm from "./FeedingForm";
    // import ProduceForm from "./ProduceForm";
    import ReturnList from "./ReturnList";
    import StatisticsSheet from "./StatisticsSheet";
    import reportdialog from "@/components/dialog"; // 错误dialog
    import eDialog from "@/components/eDialog"; // dialog
    import {mapActions} from "vuex";
    export default {
        name: "ConsumeList",
        components: {FeedingForm,ReturnList,StatisticsSheet,reportdialog,eDialog},
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                timeType:[  {i_id:0,vc_name:this.$t('promanagement_search_by_entry_time')},
                            {i_id:1,vc_name:this.$t('promanagement_search_by_accounting_time')}],
                isAccountTime:0,
                begin_time:"",
                end_time:"",
                vcName:"",
                activePage:"report/res/spread.vue",
                disabled:false,
                //在线退回
                returnlist:{},
                returnDialogVisible:false,
                //产出
                //produce:{},
                //produceDialogVisible:false,
                //投料
                feeding:{},
                feedDialogVisible:false,
                //统计
                sheet:{},
                StatisticsDialogVisible:false,
                //外
                taskDa:{},
                taskId:"",
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                i_id:"",
                title:"",
                titleID:"",
                highlightCurrentRow:true,
                tableData:[],
                baseerp:"",
                mid:0,
                tableHeight:0,

            }
        },

        watch:{
            formvalue:{
                handler(){
                   // console.log(this.formvalue,"投料—-从tasklist窜过来");
                    if (this.formvalue){
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.taskDa = this.formvalue.value;
                                this.taskId = this.formvalue.i_id;
                                this.mid=this.formvalue.i_mid;
                                //this.i_type = this.formvalue.i_type;
                                //this.apptitle = this.formvalue.title;
                                this.getConsumeList();
                                // console.log(this.taskDa,this.taskId,"this.task",this.formvalue);
                                /*if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                   // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };20250804*/
                                //console.log(this.formvalue.value.jz,"this.jz");
                                if(this.formvalue.value.jz==true){
                                    this.disabled=true;
                                }else{
                                    this.disabled=false;
                                }
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            // addLine(val){ //添加行数
            //     console.log(val,"vallll")
            //     var newValue = {
            //         i_id: val.i_id,
            //         vc_pzname: val.vc_pzname,
            //         vc_no:  val.vc_no,
            //         vc_unit:  val.vc_unit,
            //         f_innum: val.f_innum,
            //         f_innum_zb: val.f_innum_zb,
            //         f_outnum:  val.f_outnum,
            //         f_outnum_zb: val.f_outnum_zb,
            //         dt_tltime: val.dt_tltime,
            //         vc_bc: val.vc_bc,
            //         vc_scxname: val.vc_scxname,
            //         vc_note: val.vc_note,
            //         dt_createtime: val.dt_createtime,
            //         vc_lrnname: val.vc_lrnname,
            //         c_type: val.c_type,
            //         i_pid: val.i_pid
            //     };
            //     //添加新的行数
            //     this.tableData.unshift(newValue);
            // },

            //点击统计
            statistics(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.StatisticsDialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.title=this.$t('promanagement_statistical_report');
                    this.titleID="tjbb";
                    this.highlightCurrentRow=true;
                    this.sheet={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        i_mid:this.mid,
                        value:"",
                    };
                   // console.log(this.sheet,"统计sheet");
                    this.StatisticsDialogVisible=true;
                }
            },

            //报表
            async lookreport() {

                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{

                    this.sheet={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        i_mid:this.mid,
                        value:"",
                    };
                    //console.log(this.sheet,"统计sheet");
                    //var month=this.sheet.taskDa.dt_starttime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    //month = month.slice(0,7);
                    //console.log(month,"month");
                    //var month_s=this.sheet.taskDa.dt_starttime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    //var month_e=this.sheet.taskDa.dt_endtime.match(/(\d{4})(\d{2})(\d{2})/).filter((item,index) => index > 0).join('-');
                    //this.formonth=data.forMonth

                    let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                    //this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                    document.addEventListener('click',function(e){
                        loading.close()
                    })
                    let result = await this.getCurrentMenuId({path: this.$route.path});
                    // console.log("result",result)
                    if (result.i_id !== "") {
                        this.mid = result.i_id
                        sessionStorage.setItem('mids', result.i_id)
                    } else {
                        this.mid = sessionStorage.getItem('mids')
                    }
                    //console.log(this.mid,"midddddddddd==675?");

                    this.$refs.eDialog.showDialog({title:"统计",parm:{type:'OutputProductRpt',mid:this.mid,arg:{rwid:this.sheet.taskId}},w:1024,h:768});

                    loading.close();

                }

            },

            //点击退回
            returnDialog(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.returnDialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{

                    this.title=this.$t('promanagement_online_return');
                    this.titleID="zxth";
                    this.highlightCurrentRow=true;
                    this.returnlist={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        i_mid:this.mid,
                        value:"",
                        jz:this.formvalue.value.jz,
                    };
                    // console.log(this.returnlist,"returnlist");
                    this.returnDialogVisible=true;
                }
            },

            //点击产出
            // produceDialog(){
            //     if(this.formvalue.title==null||this.formvalue==null){
            //         this.produceDialogVisible=false;
            //         this.$message.error("请选择要的添加左侧单！")
            //     }else{
            //         this.title="添加产出";
            //         this.highlightCurrentRow=true;
            //         this.produce={
            //             taskId:this.taskId,
            //             taskDa:this.taskDa,
            //             c_type:16,
            //             i_id:0,
            //             value:"",
            //             page_size:1,
            //         };
            //         console.log(this.produce,"produce");
            //         this.produceDialogVisible=true;
            //     }
            // },



            //点击投料
            feedDialog(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.feedDialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.title=this.$t('promanagement_add_feed');
                    this.titleID="tjtl";
                    this.highlightCurrentRow=true;
                    this.feeding={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        c_type:7,
                        i_id:0,
                        value:"",
                        page_size:1,
                        i_mid:this.mid,
                        jz:this.formvalue.value.jz,
                    };
                    // console.log(this.feeding,"feeding");
                    this.feedDialogVisible=true;
                }
            },

            //编辑
            edit(row){
                // console.log(row,"row");
                this.highlightCurrentRow=true;
                if (row.f_innum>0){
                    this.title=this.$t('promanagement_edit_feeding');
                    this.titleID="bjtl";
                    this.feeding={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        f_innum:row.f_innum,
                        i_id:row.i_id,
                        value:row,
                        titleID:"bjtl",
                        title:this.$t('promanagement_edit_feeding'),
                        page_size:this.currentPage,
                    };
                    // console.log(this.feeding,"编辑投料feeding");
                    this.feedDialogVisible=true;
                }else if (row.f_innum<0){
                    this.title=this.$t('promanagement_online_return');
                    this.titleID="zxth";
                    this.feeding={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        f_innum:row.f_innum,
                        i_id:row.i_id,
                        value:row,
                        titleID:"zxth",
                        title:this.$t('promanagement_online_return'),
                        page_size:this.currentPage,
                    };
                    // console.log(this.feeding,"查看在线退回feeding");
                    this.feedDialogVisible=true;
                }
            },

            // cancelDialog(){
            //     if (this.title=="添加投料"||this.title=="编辑投料"){
            //         this.feedDialogVisible=false;
            //         this.highlightCurrentRow=true;
            //     }else if(this.title=="添加产出"||this.title=="编辑产出"){
            //         this.produceDialogVisible=false;
            //         this.highlightCurrentRow=true;
            //     }else if (this.title=="在线退回"){
            //         this.returnDialogVisible=false;
            //     }else if(this.title=="统计报表"){
            //         this.StatisticsDialogVisible=false;
            //     }
            // },
            cancelDialog(){
                if (this.titleID=="tjtl"||this.titleID=="bjtl"){
                    this.feedDialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.titleID=="tjcc"||this.titleID=="bjcc"){
                    this.produceDialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if (this.titleID=="zxth"){
                    this.returnDialogVisible=false;
                }else if(this.titleID=="tjbb"){
                    this.StatisticsDialogVisible=false;
                }
            },
            searchData(){
                // console.log(this.vcName,this.begin_time,this.end_time,"searchData")
                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                    return
                }
                this.getConsumeList();
            },
            //调用产出消耗列表接口
            async getConsumeList(){
                let param={
                    i_mid:this.mid,
                    i_id:this.formvalue.i_id,
                    page_size:this.currentPage,
                    page_count:13,
                    flag:0,
                    begin_time:this.begin_time?this.begin_time:'',
                    end_time:this.end_time?this.end_time:'',
                    vc_name:this.vcName,
                    isAccountTime:this.isAccountTime,
                };
                let res=await API.getConsumeList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //分页
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getConsumeList();
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },

    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 6px;
    }
    .marr4{
        margin-right: 6px;
    }
    .mrb20{
        margin-bottom: 8px;
    }

    .fr{
        float: right;
    }

    /deep/{

        .el-dialog__body{
            word-break:unset;
            padding: 5px 20px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }


    }
</style>